import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import internalState from './internalState';
import { CustomBackgroundWrapper, Ml2, Ml6 } from 'wrappers';
import { SecondaryTextSm, ClickableIcon } from 'atoms';
import { IconTextButton } from 'molecules';
import { MinusSVG, PlusSignSvg } from 'components/icons';
import { colorShade } from 'utils';

export const definition = {
  name: 'MapZoom',
  controller: Controller,
  initialProps: ({ zoom }) => ({ zoom }),
  props: internalState,
  renderIf: ({ zoom }) => !!zoom,
  elements: [
    {
      wrapper: CustomBackgroundWrapper,
      name: '__transparent__',
      displayState: ({ }) => ({ flexDirection: 'row', background: 'white', borderRadius: '10px', border: '1px solid rgba(0,0,0,0.2)', padding: '10px', alignItems: 'center' }),
      elements: [
        {
          component: SecondaryTextSm,
          name: 'Label',
          displayValue: ({ zoom }) => `${zoom}%`,
          bindings: ({ zoom }) => ({ zoom })
        },
        {
          component: wrap(ClickableIcon, Ml6),
          name: 'ZoomOut',
          bindings: ({ zoom }) => ({ zoom }),
          displayValue: ({ zoom }) => MinusSVG({ square: true, width: 20, height: 20, color: zoom == 100 ? colorShade(0.9, window?.settings?.primary_color ?? '#1DBD6B') : undefined }),
        },
        {
          component: wrap(ClickableIcon, Ml2),
          name: 'ZoomIn',
          bindings: ({ zoom }) => ({ zoom }),
          displayValue: ({ zoom }) => PlusSignSvg({ width: '20', height: '20', color: zoom == 200 ? colorShade(0.9, window?.settings?.primary_color ?? '#1DBD6B') : undefined }),
        },
        {
          component: wrap(IconTextButton, Ml6),
          name: 'Reset',
          bindings: ({ zoom }) => ({ title: 'Reset', zoom })
        },
      ]
    }
  ]
};

export default ContainerComponent(definition);